import { REQUEST, SUCCESS, FAILURE } from '../../actions/auth/requestMagicLink';

const initialState = {
  isLoading: false,
  data: null,
  error: null,
  isSuccess: false
};

export const reducer = (state = initialState, action) => {
  switch (action.type) {
    case REQUEST:
      return {
        ...state,
        isLoading: true,
        error: null,
        isSuccess: false
      };
    case SUCCESS:
      return {
        ...state,
        isLoading: false,
        data: action.payload,
        error: null,
        isSuccess: true
      };
    case FAILURE:
      return {
        ...state,
        isLoading: false,
        error: action.payload,
        isSuccess: false
      };
    default:
      return state;
  }
};
